module.exports = __webpack_public_path__ + "static/media/vehicle7.e4cdc188.svg";